import emptyTransactions from '@/assets/lotties/empty_state.json';
import loadingError from '@/assets/lotties/payment_failure.json';
import paymentSuccess from '@/assets/lotties/payment_success.json';
import paymentLoading from '@/assets/lotties/pending_validation.json';

export const EVENTS = {
  CUSTOMERS: {
    LIST_ALL: {
      REFRESH: 'customers.list_all.refresh',
      REFRESHING: 'customers.list_all.refreshing',
      REFRESH_ERROR: 'customers.list_all.refresh_error',
      REFRESHED: 'customers.list_all.refreshed'
    },
    DETAIL: {
      SHOW: 'customers.detail.show',
      REFRESH: 'customers.detail.refresh',
      REFRESHING: 'customers.detail.refreshing',
      REFRESH_ERROR: 'customers.detail.refresh_error',
      REFRESHED: 'customers.detail.refreshed'
    }
  }
};
export const ENDPOINTS = {
  CUSTOMERS: {
    GET_LIST:
      '/user/kingrecharges/all?group=lacasae&service=kingrecharges&offset={offset}&limit={limit}',
    GET_DETAIL: '/user/kingrecharges/{id}?group=lacasae&service=kingrecharges'
  }
};

export const CUSTOMERS = {
  LOTTIES: {
    EMPTY_TRANSACTION: emptyTransactions,
    LOADING_ERROR: loadingError,
    PAYMENT_ERROR: loadingError,
    PAYMENT_LOADING: paymentLoading,
    PAYMENT_SUCCESS: paymentSuccess
  }
};
